import Code from "app/models/code"

export enum Statuses {
  Requested = "requested",
  Approved = "approved",
  Rejected = "rejected",
}

export interface RequestUpdateBody {
  _id: string
  uid: string
  date: string
  from: string
  to: string
  status: Statuses
  code: Code
}

export default interface Request {
  uid?: string
  code?: Code
  date?: string
  from: string
  to: string
  hours?: number
  status: Statuses
}
